// import React from "react";
// import { Outlet, Link } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";
// import Sidebar from "./Sidebar";
// import Footer from "./Footer";
// import Header from "./Header";

// const Layout = () => {
//   return (
//     <div className="container-fluid vh-100 d-flex flex-column p-0 ">
//       <div className="row flex-grow-1 overflow-hidden">
//         <Sidebar />

//         {/* Main content area */}
//         <div className="col-md-9 col-lg-10 d-flex flex-column p-0 h-100">
//           {/* Navbar at the top */}
//           <Header />

//           {/* This div will now properly scroll */}
//           <div
//             className="flex-grow-1 overflow-auto p-3"
//             style={{
//               minHeight: 0,
//               backgroundImage: 'url("/images/flagbg.jpg")',
//               backgroundSize: "cover",
//               backgroundPosition: "center",
//               backgroundRepeat: "no-repeat",
//             }}
//           >
//             <Outlet />
//           </div>

//           <Footer />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Layout;

// 2nd scenario

// import React from "react";
// import { Outlet } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";
// import Sidebar from "./Sidebar";
// import Footer from "./Footer";
// import Header from "./Header";

// const Layout = () => {
//   return (
//     <div className="container-fluid vh-100 d-flex flex-column p-0">
//       <div className="row flex-grow-1 overflow-hidden">
//         <Header />

//         <div className="col-12 p-0">
//           <Sidebar />
//         </div>

//         <div className="col-12 d-flex flex-column p-0 h-100">
//           <div
//             className="flex-grow-1 overflow-auto p-3"
//             style={{
//               minHeight: 0,
//               background: "linear-gradient(to right, #ffffff, #B9D9F0)",
//             }}
//           >
//             <Outlet />
//           </div>

//           <Footer />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Layout;

import React from "react";
import { Outlet } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import Header from "./Header";
import Header2 from "./Header2";

const Layout = () => {
  
  return (
    <div className="container-fluid vh-100 d-flex flex-column p-0">
      {/* Header at the top - fixed height */}
      {/* <Header /> */}
      {/* <Header2 /> */}

      <div className="row flex-grow-1 m-0 overflow-hidden">
        {/* Sidebar and content container */}
        <div className="col-12 p-0 d-flex flex-column h-100">
          {/* Sidebar */}
          <Sidebar />

          {/* Main scrollable content */}
          {/* <div
            className="flex-grow-1 overflow-hidden d-flex"
            style={{
              background:
                "linear-gradient(to bottom, #ffffff 40%, #B9D9F0 100%)",
            }}
          >
            <div className="overflow-auto w-100 p-3">
              <Outlet />
            </div>
          </div> */}
          <div
            className="flex-grow-1 overflow-hidden d-flex"
            style={{
              position: "relative",
              background:
                "linear-gradient(to bottom, #ffffff 40%, #B9D9F0 100%)",
            }}
          >
            <div
              style={{
                content: "''",
                backgroundImage: `url('/images/schoold-home-banner.png')`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "50%",
                opacity: 0.15,
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 0,
              }}
            />

            <div
              className="overflow-auto w-100 py-3 px-5"
              style={{
                zIndex: 1,
                position: "relative",
                // marginLeft: "40px",
                // marginRight: "40px",
                // previously no margin left and right 20px min limit
              }}
            >
              <Outlet />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
